import { END_POINTS } from "../constants/urls";
import { CommonResponseType } from "../types/General";
import emptySplitApi from "../utils/rtk";

export const usersApi = emptySplitApi.injectEndpoints({
  endpoints: (builder) => ({
    getUsers: builder.query<
      CommonResponseType & { data: any },
      {
        search?: string;
        limit?: number;
        page?: number;
      }
    >({
      query: ({ page, limit, search }) => {
        const params = new URLSearchParams();

        params.append("page", String(page));
        params.append("limit", String(limit));

        if (search) params.append("search", search);
        return {
          url: `${END_POINTS.getUsers}?${params.toString()}`,
          method: "GET",
        };
      },
    }),
    getUserById: builder.query<
      CommonResponseType & { data: any },
      {
        id: string;
      }
    >({
      query: ({ id }) => ({
        url: `${END_POINTS.getUserById}/${id}`,
        method: "GET",
      }),
    }),
    addUser: builder.mutation<CommonResponseType, {}>({
      query: (body) => ({
        url: END_POINTS.addUser,
        method: "POST",
        body,
      }),
    }),
    updateUsers: builder.mutation<CommonResponseType, { body: any; id: any }>({
      query: ({ body, id }) => ({
        url: `${END_POINTS.updateUsers}/${id}`,
        method: "PUT",
        body,
      }),
    }),
    deleteUser: builder.mutation<CommonResponseType, { id: any }>({
      query: ({ id }) => ({
        url: `${END_POINTS.deleteUser}/${id}`,
        method: "DELETE",
      }),
    }),
    exportUsers: builder.query<
      { data: Blob; meta?: any },
      {
        search?: string;
        limit?: number;
        page?: number;
      }
    >({
      query: ({ page, limit, search }) => {
        const params = new URLSearchParams();

        params.append("page", String(page));
        params.append("limit", String(limit));

        if (search) params.append("search", search);
        // Set Accept header based on export type
        let accept = "text/csv";
        // if (body?.exportType === "excel") {
        //   accept =
        //     "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
        // } else if (body?.exportType === "pdf") {
        //   accept = "application/pdf";
        // }

        return {
          url: `${END_POINTS.exportUsers}?${params.toString()}`,
          method: "GET",
          responseHandler: (response: { blob: () => any }) => response.blob(), //  important
          headers: {
            Accept: accept,
          },
        };
      },
    }),
    getProductByUserId: builder.query<CommonResponseType & { data: any }, {}>({
      query: (id) => ({
        url: `${END_POINTS.getProductById}?userId=${id}`,
        method: "GET",
      }),
    }),
  }),
});

export const {
  useAddUserMutation,
  useDeleteUserMutation,
  useLazyExportUsersQuery,
  useLazyGetUserByIdQuery,
  useLazyGetUsersQuery,
  useGetUsersQuery,
  useUpdateUsersMutation,
  useGetUserByIdQuery,
  useLazyGetProductByUserIdQuery,
} = usersApi;
